.sidebar {
	position: sticky;
	top: var(--mantine-spacing-md);
}
